import { useRecoilState } from "recoil";
import { logIdState } from "../states/loginLog";
import {
  ACCESS_TOKEN,
  RECOIL_PERSIST_KEY,
  REFRESH_TOKEN,
} from "../sharedStrings";
import { SocialAuth } from "../auth/socialAuth";

export const useLogout = () => {
  const [, setLogId] = useRecoilState(logIdState);

  const logout = async () => {
    try {
      setLogId(null);
      // 소셜 로그아웃 사용 (백엔드 로그아웃 API 호출 포함)
      await SocialAuth.logout();
    } catch (error) {
      console.error("로그아웃 오류:", error);
      // 오류가 발생해도 로컬 데이터는 정리
      localStorage.removeItem(ACCESS_TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
      localStorage.removeItem(RECOIL_PERSIST_KEY);
      window.location.href = "/auth/login";
    }
  };

  return logout;
};
